import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import clsx from 'clsx';
import { IconButton } from '@paypalcorp/pp-react-icon-button';
import { V2InformationIcon, QuestionAltIcon, V2CloseIcon, CloseIcon, InfoAltIcon, CheckCircleAltIcon, WarningAltIcon, CriticalAltIcon, V2CheckmarkBackgroundIcon, V2WarningIcon, V2CriticalIcon } from '@paypalcorp/pp-react-icons';
import { useTheme } from '@paypalcorp/pp-react-theme';
import '../__generated__/styles/alert.css';

var styles = {"ppvx_alert":"ppvx_alert___2-8-4","ppvx_alert__svg-icon":"ppvx_alert__svg-icon___2-8-4","ppvx_alert__close-btn--svg":"ppvx_alert__close-btn--svg___2-8-4","ppvx_alert__close-btn":"ppvx_alert__close-btn___2-8-4","ppvx_alert--type_attention":"ppvx_alert--type_attention___2-8-4","ppvx_alert--type_warning":"ppvx_alert--type_warning___2-8-4","ppvx_alert--type_info":"ppvx_alert--type_info___2-8-4","ppvx_alert--type_success":"ppvx_alert--type_success___2-8-4","ppvx_alert--type_error":"ppvx_alert--type_error___2-8-4","ppvx_alert--with-svg-icon":"ppvx_alert--with-svg-icon___2-8-4","ppvx_alert--no-close-btn":"ppvx_alert--no-close-btn___2-8-4","ppvx--v2":"ppvx--v2___2-8-4","ppvx--v1":"ppvx--v1___2-8-4"};

var _excluded = ["className", "type", "typeIconAriaLabel", "closeButton", "closeButtonLabel", "children", "theme"],
    _excluded2 = ["className"];
var icons = {
  info: InfoAltIcon,
  success: CheckCircleAltIcon,
  warning: WarningAltIcon,
  attention: WarningAltIcon,
  error: CriticalAltIcon
};
var v2Icons = {
  info: V2InformationIcon,
  success: V2CheckmarkBackgroundIcon,
  warning: V2WarningIcon,
  attention: V2WarningIcon,
  error: V2CriticalIcon
};

var Alert = function (_ref) {
  var _clsx;

  var className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'info' : _ref$type,
      _ref$typeIconAriaLabe = _ref.typeIconAriaLabel,
      typeIconAriaLabel = _ref$typeIconAriaLabe === void 0 ? type : _ref$typeIconAriaLabe,
      closeButton = _ref.closeButton,
      _ref$closeButtonLabel = _ref.closeButtonLabel,
      closeButtonLabel = _ref$closeButtonLabel === void 0 ? 'close alert' : _ref$closeButtonLabel,
      children = _ref.children,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _theme = useTheme('Alert', theme);

  var isThemeV2 = _theme && _theme === 'v2';

  if (_theme !== 'v2') {
    console.warn('Alerts 1.0 styles are deprecated. Use Alerts 2.0 styles and refer to our Migration Guide on how to use 2.0 styles/components.');
  }
  /* istanbul ignore next */


  var AlertStatusIcon = isThemeV2 ? v2Icons[type] || V2InformationIcon : icons[type] || QuestionAltIcon;
  var closeIcon, btnType, btnSize;

  if (isThemeV2) {
    closeIcon = V2CloseIcon;
    btnType = 'tertiary';
    btnSize = 'sm';
  } else {
    closeIcon = CloseIcon;
    btnType = 'primary';
  }

  var alertClasses = clsx(styles.ppvx_alert, styles['ppvx_alert--with-svg-icon'], (_clsx = {}, _defineProperty(_clsx, styles["ppvx_alert--type_".concat(type)], type), _defineProperty(_clsx, styles["ppvx_alert--no-close-btn"], !closeButton), _defineProperty(_clsx, styles['ppvx--v2'], isThemeV2), _clsx), className);
  var closeBtnEl;

  if (closeButton) {
    var closeButtonCls = closeButton.className,
        otherProps = _objectWithoutProperties(closeButton, _excluded2);

    var closeButtonClass = clsx(styles['ppvx_alert__close-btn--svg'], closeButtonCls);
    closeBtnEl = closeButton && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, _extends({
      buttonType: btnType,
      size: btnSize,
      theme: isThemeV2 && 'v2',
      svgIconComponent: closeIcon,
      className: closeButtonClass
    }, otherProps), closeButtonLabel));
  }

  var alertIconClass = styles['ppvx_alert__svg-icon'];
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "alert",
    className: alertClasses
  }, rest), /*#__PURE__*/React.createElement(AlertStatusIcon, {
    size: "sm",
    className: alertIconClass,
    role: "img",
    "aria-label": typeIconAriaLabel
  }), children, closeBtnEl);
};

export { Alert };
